import React, {useEffect, useRef} from 'react';
import {Animated, StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import RadarDot from '@/Atoms/RadarDot';
import {lbColors, lbRadius} from '../leaderboardTheme';

/** Pulsing green "LIVE" badge. */
export default function LiveBadge() {
  const pulse = useRef(new Animated.Value(0.4)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(pulse, {
          toValue: 1,
          duration: 900,
          useNativeDriver: false,
        }),
        Animated.timing(pulse, {
          toValue: 0.4,
          duration: 900,
          useNativeDriver: false,
        }),
      ]),
    );
    loop.start();
    return () => loop.stop();
  }, [pulse]);

  return (
    <View style={styles.live}>
      {/* radar ping instead of a plain opacity blink */}
      <RadarDot color={lbColors.green} size={6} />
      <CCText fontSize={11} fontWeight="bold" color={lbColors.greenInk}>
        LIVE
      </CCText>
    </View>
  );
}

const styles = StyleSheet.create({
  live: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: lbColors.greenBg,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: lbRadius.pill,
    gap: 6,
  },
  liveDot: {
    width: 7,
    height: 7,
    borderRadius: 4,
    backgroundColor: lbColors.green,
  },
});
